import courseTagsServices from '../services/courseTagsServices';

import { CourseTagsAction } from '../types/CourseTagsAction';
import { CourseTagsBody } from '../types/CourseTagsBody';
import { TagTypesBody } from '../types/TagTypesBody';

const courseTagsList = (limit:number, skip:number) => (dispatch: any) => {
	const success = (data: CourseTagsBody[]): CourseTagsAction =>
		({ type: 'COURSE_TAGS_LIST_SUCCESS', data });

	courseTagsServices.list(limit,skip)
		.then((res: CourseTagsBody[]) => { dispatch(success(res)) });
}

const courseTagTypesList = () => (dispatch: any) => {
	const success = (data: TagTypesBody[]): CourseTagsAction =>
		({ type: 'COURSE_TAG_TYPES_LIST_SUCCESS', data });

	courseTagsServices.tagTypes()
		.then((res: TagTypesBody[]) => { dispatch(success(res)) });
}

export default {
	courseTagsList,
	courseTagTypesList,
};